var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArchiveDeleteInboundIsUsingFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 16c0 7.732-6.268 14-14 14S2 23.732 2 16C2 8.269 8.268 2 16 2s14 6.269 14 14z",
    fill: "#EAEAEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.778 9.635l-1.414-1.414L16 14.585 9.636 8.221 8.222 9.635 14.586 16l-6.364 6.365 1.414 1.414L16 17.413l6.364 6.365 1.414-1.414L17.414 16l6.364-6.364z",
    fill: "#6D6D6D"
  })));
}

export default SvgIconArchiveDeleteInboundIsUsingFilled;